export default {
  form: 'myForm',
  fields: ['name', 'address', 'gender']
};



/** WEBPACK FOOTER **
 ** ./utils/config.js
 **/